import React from "react";
import "./Payment.css";

const Payment = () => {
  return (
    <div className="payment">
      <p>
        Online payment options are not available at the moment.
        <br /> For the time being, we are only offering cash on delivery. Thank
        you!
      </p>
    </div>
  );
};

export default Payment;
